import { CellTextAlignment, GridColumnType, GridFieldType, GridPageTarget, IGridColumn, IPageLink, Sort } from "../../../../base/models";
import { DisplayFormat, IDataSource, PageMode } from "../../../../base/types";

import { EditPageLink } from "../../page-link";
import { EditTableLookup } from "../../table-lookup";
import { MUIIcon } from "../../../../widgets";
import { SelectAttribute } from "../../SelectAttribute";
import { SelectDisplayFormat } from "../../SelectDisplayFormat";
import { useState } from "react";

export const NewGridColumn = ({ dataSource, onAdd, onCancel }: {
    dataSource?: IDataSource,
    onAdd: (filter: IGridColumn) => void,
    onCancel: () => void,
}) => {
    const initColumn: IGridColumn = {
        header: '',
        field: '',
        columnType: GridColumnType.Normal,
        fieldType: GridFieldType.Text,
        sortable: true,
        alignment: CellTextAlignment.Default,
        sort: Sort.Default,
        filter: false,
        cellClass: '',
        headerClass: '',
        minWidth: 0,
        maxWidth: 0,
    };
    const initPageLink: IPageLink = { pageMode: PageMode.View }
    const [localColumn, updateColumn] = useState<IGridColumn>(initColumn);

    const handleAddColumn = () => {
        onAdd(localColumn)
        updateColumn(initColumn)
    }

    const handleCancel = () => {
        updateColumn(initColumn)
        onCancel()
    }

    return (
        <div>
            <div className="row g-2 gy-3 mb-2">
                <div className="col-lg-3 col-md-3 col-sm-6">
                    <label className="form-label fs-7 fw-semibold">Header</label>
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        onChange={(e) => updateColumn({ ...localColumn, header: e.target.value })}
                        value={localColumn.header || ''}
                    />
                </div>

                <div className="col-lg-3 col-md-3 col-sm-6">
                    <label className="form-label fs-7 fw-semibold">Field</label>
                    <SelectAttribute
                        attributes={dataSource?.attributes || []}
                        value={localColumn.field}
                        onChange={(field) => updateColumn({ ...localColumn, field })} />
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6">
                    <label className="form-label fs-7 fw-semibold">Sequence</label>
                    <input
                        type="number"
                        className="form-control form-control-sm"
                        onChange={(e) => updateColumn({ ...localColumn, sequence: Number(e.target.value) })}
                        value={localColumn.sequence}
                    />
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6">
                    <label className="form-label fs-7 fw-semibold">Text Alignment</label>
                    <select
                        className="form-select form-select-sm"
                        onChange={(e) => updateColumn({ ...localColumn, alignment: e.target.value as CellTextAlignment })}
                        value={localColumn.alignment || CellTextAlignment.Default}
                    >
                        <option value={CellTextAlignment.Default}></option>
                        <option value={CellTextAlignment.Start}>Start</option>
                        <option value={CellTextAlignment.Center}>Center</option>
                        <option value={CellTextAlignment.End}>End</option>
                    </select>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6">
                    <label className="form-label fs-7 fw-semibold">sort</label>
                    <select
                        className="form-select form-select-sm"
                        onChange={(e) => updateColumn({ ...localColumn, sort: e.target.value as Sort })}
                        value={localColumn.sort || Sort.Default}
                    >
                        <option value={Sort.Default}></option>
                        <option value={Sort.Ascending}>Ascending</option>
                        <option value={Sort.Descending}>Descending</option>
                    </select>
                </div>
            </div>
            <div className="row g-2 gy-3 my-2">
                <div className="col-lg-3 col-md-3 col-sm-6">
                    <div className="form-check form-switch">
                        <label className="form-check-label" htmlFor="resizable">Resizable</label>
                        <input className="form-check-input"
                            type="checkbox"
                            id="resizable"
                            name="resizable"
                            onChange={(e) => updateColumn({ ...localColumn, resizable: e.target.checked })}
                            checked={localColumn.resizable === true} />
                    </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6">
                    <div className="form-check form-switch">
                        <label className="form-check-label" htmlFor="resizable">Sortable</label>
                        <input className="form-check-input"
                            type="checkbox"
                            id="sortable"
                            name="sortable"
                            onChange={(e) => updateColumn({ ...localColumn, sortable: e.target.checked })}
                            checked={localColumn.sortable === true} />
                    </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6">
                    <div className="form-check form-switch">
                        <label className="form-check-label" htmlFor="resizable">Filter</label>
                        <input className="form-check-input"
                            type="checkbox"
                            id="filter"
                            name="filter"
                            onChange={(e) => updateColumn({ ...localColumn, filter: e.target.checked })}
                            checked={localColumn.filter === true} />
                    </div>
                </div>
            </div>
            <div className="row g-2 gy-3 my-2">
                <div className="col-lg-2 col-md-3 col-sm-6">
                    <label className="form-label fs-7 fw-semibold">Width</label>
                    <input
                        type="number"
                        className="form-control form-control-sm"
                        onChange={(e) => updateColumn({ ...localColumn, width: Number(e.target.value) })}
                        value={localColumn.width}
                    />
                </div>
                <div className="col-lg-2 col-md-3 col-sm-6">
                    <label className="form-label fs-7 fw-semibold">Min. Width</label>
                    <input
                        type="number"
                        className="form-control form-control-sm"
                        onChange={(e) => updateColumn({ ...localColumn, minWidth: Number(e.target.value) })}
                        value={localColumn.minWidth}
                    />
                </div>
                <div className="col-lg-2 col-md-3 col-sm-6">
                    <label className="form-label fs-7 fw-semibold">Max. Width</label>
                    <input
                        type="number"
                        className="form-control form-control-sm"
                        onChange={(e) => updateColumn({ ...localColumn, maxWidth: Number(e.target.value) })}
                        value={localColumn.maxWidth}
                    />
                </div>

                <div className="col-lg-3 col-md-3 col-sm-6">
                    <label className="form-label fs-7 fw-semibold">Header Class</label>
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        onChange={(e) => updateColumn({ ...localColumn, headerClass: e.target.value })}
                        value={localColumn.headerClass || ''}
                    />
                </div>

                <div className="col-lg-3 col-md-3 col-sm-6">
                    <label className="form-label fs-7 fw-semibold">Cell Class</label>
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        onChange={(e) => updateColumn({ ...localColumn, cellClass: e.target.value })}
                        value={localColumn.cellClass || ''}
                    />
                </div>
            </div>
            <div className="row g-2 gy-3 my-2">
                <div className="col-lg-3 col-md-3 col-sm-6">
                    <label className="form-label fs-7 fw-semibold">Data Type</label>
                    <select
                        className="form-select form-select-sm"
                        onChange={(e) => updateColumn({ ...localColumn, fieldType: e.target.value as GridFieldType })}
                        value={localColumn.fieldType || GridFieldType.Text}
                    >
                        <option value={GridFieldType.Text}>Text</option>
                        <option value={GridFieldType.Number}>Number</option>
                        <option value={GridFieldType.Boolean}>Boolean</option>
                        <option value={GridFieldType.Money}>Money</option>
                        <option value={GridFieldType.Date}>Date</option>
                        <option value={GridFieldType.Time}>Time</option>
                        <option value={GridFieldType.DateTime}>Datetime</option>
                        <option value={GridFieldType.Lookup}>Lookup</option>
                    </select>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6">
                    <label className="form-label fs-7 fw-semibold">Display Format</label>
                    <SelectDisplayFormat
                        value={localColumn.displayFormat || DisplayFormat.Normal}
                        onChange={(value) => { updateColumn({ ...localColumn, displayFormat: value }) }} />
                </div>

                <div className="col-lg-3 col-md-3 col-sm-6">
                    <label className="form-label fs-7 fw-semibold">Column Type</label>
                    <select
                        className="form-select form-select-sm"
                        onChange={(e) => updateColumn({ ...localColumn, columnType: e.target.value as GridColumnType })}
                        value={localColumn.columnType || GridColumnType.Normal}
                    >
                        <option value={GridColumnType.Normal}></option>
                        <option value={GridColumnType.PageLink}>Page Link</option>
                        <option value={GridColumnType.DownloadLink}>Download Link</option>
                    </select>
                </div>

                {(localColumn.fieldType === GridFieldType.Lookup) &&
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <label className="form-label fs-7 fw-semibold">Lookup</label>
                        <div className="border p-5">
                            <EditTableLookup
                                dataSource={dataSource}
                                tableLookup={localColumn.lookup || {}}
                                onChange={(value) => updateColumn({ ...localColumn, lookup: value })} />
                        </div>
                    </div>
                }

                {(localColumn.columnType === GridColumnType.DownloadLink) && <>
                    <div className="col-lg-12">
                        <label className="form-label fs-7 fw-semibold">Url Field</label>
                        <SelectAttribute
                            attributes={dataSource?.attributes || []}
                            value={localColumn.urlField}
                            onChange={(urlField) => updateColumn({ ...localColumn, urlField })} />
                    </div>
                </>}

                {(localColumn.columnType === GridColumnType.PageLink) &&
                    <>
                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <label className="form-label fs-7 fw-semibold">Page Target</label>
                            <select
                                className="form-select form-select-sm"
                                onChange={(e) => updateColumn({ ...localColumn, pageTarget: e.target.value as GridPageTarget })}
                                value={localColumn.pageTarget || GridPageTarget.Redirect}
                            >
                                <option value={GridPageTarget.Redirect}>Redirect</option>
                                <option value={GridPageTarget.NewTab}>New Tab</option>
                                <option value={GridPageTarget.Dialog}>Dialog</option>
                                <option value={GridPageTarget.Offcanvas}>Offcanvas</option>
                            </select>
                        </div>

                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <label className="form-label fs-7 fw-semibold">Page Link</label>
                            <div className="border p-5">
                                <EditPageLink
                                    dataSource={dataSource}
                                    pageLink={localColumn.pageLink || initPageLink}
                                    onChange={(value) => updateColumn({ ...localColumn, pageLink: value })} />
                            </div>
                        </div>
                    </>
                }
            </div>
            <div className="my-3 text-end">
                <button
                    type="button"
                    onClick={handleAddColumn}
                    className="btn btn-primary btn-sm me-3 py-2">
                    <MUIIcon iconName={"AddOutlined"} className="me-1" />
                    Add Column
                </button>
                <button
                    type="button"
                    onClick={handleCancel}
                    className="btn btn-secondary btn-sm py-2">
                    <MUIIcon iconName={"CancelOutlined"} className="me-1" />
                    Cancel
                </button>
            </div>
        </div>
    )
}